import { createApi } from '@reduxjs/toolkit/query/react'
import { MANAGE_DISCAHARGE_LIST_NEW, MANAGE_DISCHARGE_LIST, MANAGE_DISCHARGE_VIEW } from 'config/apiPaths';
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const dischargeApi = createApi({
    reducerPath: 'dischargeApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/discharge",
    }),
    tagTypes: ["DischargeList", "DischargeDetails"],
    endpoints: (builder) => ({
        // get disharge list
        getDischargeList: builder.query({
            query: ({ search = "", grade, school, page = 1, limit = 10, client_type = "", sort = { column: "id", direction: "ASC" } }) => {
                return ({
                    method: "PATCH",
                    url: MANAGE_DISCHARGE_LIST,
                    data: { search, page, limit, sort, client_type, grade: grade?.value, /*school: school?.value*/ },
                })
            },
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["DischargeList"]
        }),

        // get disharge details
        getDischargeDetails: builder.query({
            query: (id) => ({
                method: "GET",
                url: `${MANAGE_DISCHARGE_VIEW}/${id}`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["DischargeDetails"]
        }),

        getDischargeListNew: builder.query({
            query: ({ search = "", grade, school, page = 1, limit = 10, client_type = "", sort = { column: "id", direction: "ASC" } }) => {
                return ({
                    method: "PATCH",
                    url: MANAGE_DISCAHARGE_LIST_NEW,
                    data: { search, page, limit, sort, client_type, grade: grade?.value, /*school: school?.value*/ },
                })
            },
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["DischargeList"]
        }),
    }),
})

export const {
    useGetDischargeListQuery,
    useGetDischargeDetailsQuery,
    useGetDischargeListNewQuery
} = dischargeApi;